/**
 * Hash utilities for device synchronization
 * Used to generate device-specific identifiers
 */

import MD5 from 'crypto-js/md5';

/**
 * Generate MD5 hash of a string (matching backend implementation)
 * Backend reference: crypto/md5 package in Go
 *
 * This matches the backend's implementation:
 * ```go
 * hash := md5.Sum([]byte(personData.PersonID))
 * userID := hex.EncodeToString(hash[:])
 * ```
 *
 * @param input - String to hash
 * @returns Lowercase hex string (32 characters)
 */
export function md5(input: string): string {
  return MD5(input).toString();
}
